//-------------------------------------------->
//-->  Na bar links data
//-------------------------------------------->

const Links = [
  {
    text: 'About',
    url: '/',
  },
  {
    text: 'Products',
    url: '/',
  },
  ,
  {
    text: 'Community',
    url: '/',
  },
];

export default Links;
